import React, { Component } from 'react';
import { Table } from "react-bootstrap";

class OrdenCi extends Component {
    state = {
        preloader: "",
        profes: []
    }

    componentWillReceiveProps = (props) => {
        this.setState({
            preloader: props.preloader,
            profes: props.prof
        })
    }

    openW = (seccion, codigo, materia, nombre, carrera, semestre, cualitativo, cuantitativo) => (e) => {
        this.props.funcion(seccion, codigo, materia, nombre, carrera, semestre, cualitativo, cuantitativo)
    }

    listProf = () => {
        let { preloader, profes } = this.state;

        const styles = {
            padding: 5, fontSize: 10
        }
        
        if (profes.length === 0 ) return (
            <tr>
                <td colSpan={3} align="center"><i className={preloader.icon}></i> {preloader.text}</td>
            </tr>
        )

        let nombre = (nombre1, nombre2, apellido1, apellido2) => {

            (nombre2 === null) ? nombre2 = "" : nombre2 = nombre2;
            (apellido2 === null) ? apellido2 = "" : apellido2 = nombre2;

            return `${nombre1} ${nombre2} ${apellido1} ${apellido2}`;
        }
        console.log(profes);
        return(
            profes.map(option => (
                <tr key={option.id}>
                    <td style={styles}>
                        <div><strong>{option.carrera_name} {option.semestre_name}</strong></div>
                        <div>{option.codigo} - <strong className="text-danger">{option.materia_name}</strong> {option.nombre}</div>
                    </td>
                    <td style={styles}>{nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)}</td>
                    <td align="center" style={styles}>
                        <button className="btn btn-primary" onClick={this.openW(option.id, option.codigo, option.materia_name, option.nombre, option.carrera_name, option.semestre_name, option.cualitativo, option.cuantitativo)} title="Editar Calificaciones de esta Sección" style={{borderWidth: 1}}><i className="fa fa-edit"></i></button>
                    </td>
                </tr>
            ))
        )
    }

    contenido = () => {
        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", maxHeight: "75vh", overflowY: "auto"}}>
                <Table striped hover bordered>
                    <tbody>
                        <tr className="custon-back-color">
                            <td width="60%" style={styles}><strong>Código - Materia - Sección</strong></td>
                            <td width="40%" style={styles}><strong>Profesor</strong></td>
                            <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                        </tr>
                        {this.listProf()}
                    </tbody>
                </Table>
            </div>
        )
    }

    render() { 
        return (
            <div>{this.contenido()}</div>
        );
    }
}
 
export default OrdenCi;


// WEBPACK FOOTER //
// ./src/views/Academicos/CalificacionesContent/OrdenCi.jsx